export const SKIN = {
  general: 'general',
  standard: 'standard',
  danger: 'danger',
  success: 'success',
  neutral: 'neutral',
  neutralLight: 'neutralLight',
  warning: 'warning',
  warningLight: 'warningLight',
  urgent: 'urgent',
  neutralStandard: 'neutralStandard',
  neutralSuccess: 'neutralSuccess',
  neutralDanger: 'neutralDanger',
  premium: 'premium',
};

export const TYPE = {
  solid: 'solid',
  outlined: 'outlined',
  transparent: 'transparent',
};

export const SIZE = {
  medium: 'medium',
  small: 'small',
  tiny: 'tiny',
};
